import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { List, ListItem } from '@dbk/ui-list';

/* WMCE-2889, WMCE-2891 Extended View for Search functionality */
class SearchViewList extends PureComponent{
    constructor(props){
        super(props);

        this.state= {
            accounts: [],
            showButton: false
        }    
        
        this.renderMainListView = this.renderMainListView.bind(this);
        this.renderSubListView = this.renderSubListView.bind(this);
        this.handleAccountSelectedItem = this.handleAccountSelectedItem.bind(this);
    }

    deselectAll = () => {
        const getList = this.props.rmAccess.contractsData;
        const selectedOptions = [];
        getList.forEach((item) => {
            item.isSelected = false;
            selectedOptions.push(item);
        }); 
        this.props.rmAccess.setContractsData(selectedOptions);
      }
    
    /*Handler to show included accounts when any contract is selected */
    handleSelectedItem = async (item) => {
        this.deselectAll();
        item.isSelected = true;
        const contractValue = this.props.rmAccess.contractsData;
        const accounts =  contractValue.filter((data) => {
        if(data.role){
            return data.contract === item.contract;
         }
        });
        this.setState({
            accounts
        });
        await this.props.rmAccess.setContractSelected(item.contract);
        this.handleAccountSelectedItem();
    }

    handleAccountSelectedItem(){
        this.setState({
            showButton: true,
        })
    }

    handleSessionClick = () => {
        this.props.rmAccess.startDWOSession(this.props.rmAccess.selectedContract);
    }

    /* Function to render the left side contract list for Search Functionality */
    renderMainListView(options) {
        /* Added isSelected key in the options at service factory */
        const { i18n: { messages } } = this.props;
        const arrayList = options;
        const selectedOptions = [];
        arrayList.forEach((dataRow) => {
            let isPresent = false;
            selectedOptions.forEach((item) =>{
                if(item.contract === dataRow.contract)
                 isPresent = true;
          });
          if(!isPresent)
          selectedOptions.push(dataRow)
        });
        return (
            <div className="rm-list-contracts-container rm-list-container">
                <List fullWidth>
                    <ListItem className="list-header-color" disabled>
                            <span className="rm-list-top-header">
                                {messages['app.rmAccess.title.contractno']}
                            </span>
                            <span className="rm-list-top-header">
                                {messages['app.rmAccess.title.username']}
                            </span>
                    </ListItem>
                    </List>
                    <List className="list-height" fullWidth>
                    {selectedOptions && selectedOptions.map((item) => (
                        <ListItem className={item.isSelected === false?"list-color ": "list-color selected-item-style"} onClick= {()=> this.handleSelectedItem(item)}>
                                <span className="rm-listitem1 rm-general-font">
                                {item.contract}
                                </span>
                                <span className="rm-listitem2 rm-list-textFont">
                                {item.userName}
                                </span>
                        </ListItem>
                    ))}
                </List>
            </div>
        )
    }

    /* Function to render the right side Included Accounts list for Search Functionality */
    renderSubListView(options) {
        const { i18n: { messages } } = this.props;
        return (
            <div className="rm-list-accounts-container rm-list-container">
                <List fullWidth >
                    <ListItem className="list-header-color" disabled>
                            <span className="rm-list-top-header">
                                {messages['app.rmAccess.title.accountno']}
                            </span>
                            <span className="rm-list-top-header">
                                {messages['app.rmAccess.title.authority']}
                            </span>
                    </ListItem>
                    </List>
                    <List className="list-height" fullWidth>
                    {options && options.map((item) => (
                        <ListItem className="list-color">
                                <span className="rm-general-font rm-sublistitem1">
                                {item.bpId}
                                </span>
                                <span className="rm-listitem2 rm-list-textFont">
                                {item.role}
                                </span>
                        </ListItem>
                    ))}
                </List>
            </div>
        )
    }

    render(){
        const { i18n: { messages },
                rmAccess: { contractsData, loading } } = this.props;
        return (
            <div>
                <div className= "rm-columns">
                    <span className="rm-general-font">{messages['app.rmAccess.contractList.title']}</span>
                    <span className="rm-general-font rm-accounts-align">{messages['app.rmAccess.accounts.title']}</span>
                </div>
                <div className="rm-listview-container">
                    {this.renderMainListView(contractsData)}
                    {this.renderSubListView(this.state.accounts)}
                </div>
                <div className="rm-startbutton-container">
                    <Button 
                        className="button-height"
                        loading={loading} 
                        primary= {this.state.showButton}
                        tertiary ={!this.state.showButton}
                        disabled={!this.state.showButton}
                        size='large'
                        onPress={this.handleSessionClick}
                    >{messages['app.rmAccess.start.sessionButton']}</Button>
                </div>
            </div>
        );
    }

}

export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        rmAccess:{
            loading: true,
            startDWOSession: { $call: 'startRMSession' },
            showSpinner: true,
            contractsData: true,
            selectedContract: true,
            setContractsData: {$set:' contractsData'},
            setContractSelected: {$set: 'selectedContract'}
        }
    }
})(SearchViewList);